import { memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ClockIcon } from "../../assets/content-overview-images/clock.svg";
import "./summary-card.css";

export const SummaryCard = memo(function SummaryCard({
  total,
  icon,
  title,
  description,
  meta,
  href,          // ← лінк для всієї картки
}) {
  const navigate = useNavigate();

  const onCardClick = useCallback(
    (e) => {
      if (!href) return;

      // Ctrl/Cmd/middle click — в нову вкладку
      if (e.ctrlKey || e.metaKey || e.button === 1) {
        window.open(href, "_blank", "noopener,noreferrer");
      } else {
        navigate(href);
      }
    },
    [href, navigate]
  );

  const metaItems = Array.isArray(meta) ? meta.filter(Boolean) : [];

  const showEmpty = typeof total === "number" && total === 0 && metaItems.length === 0;

  const handleMetaClick = useCallback(
    (e, m) => {
      if (!m?.href) return;
      e.preventDefault();
      e.stopPropagation();

      if (e.ctrlKey || e.metaKey || e.button === 1) {
        window.open(m.href, "_blank", "noopener,noreferrer");
      } else {
        navigate(m.href);
      }
    },
    [navigate]
  );

  return (
    <div
      className={href ? "summary-card summary-card--clickable" : "summary-card"}
      role={href ? "button" : undefined}
      tabIndex={href ? 0 : undefined}
      onClick={href ? onCardClick : undefined}
      onKeyDown={(e) => {
        if (!href) return;
        if (e.key === "Enter" || e.key === " ") onCardClick(e);
      }}
    >
      <div className="summary-card__top">
        <div className="summary-card__count">
          {typeof total === "number" ? total : "—"}
        </div>

        {icon ? <span className="summary-card__icon">{icon}</span> : null}
      </div>

      <div className="summary-card__body">
        <div className="summary-card__title">{title}</div>

        {description ? (
          <div className="summary-card__description">{description}</div>
        ) : (
          <div className="summary-card__description summary-card__description--placeholder">
            &nbsp;
          </div>
        )}
      </div>

      <div className="summary-card__meta">
        {showEmpty ? (
          <span className="summary-card__chip">empty</span>
        ) : (
          metaItems.map((m, idx) => {
            if (m.type === "pending") {
              const text =
                typeof m.value === "number" ? `${m.value} pending` : "pending";

              return (
                <button
                  key={`m-${idx}`}
                  type="button"
                  className="summary-card__chip summary-card__meta-btn"
                  onClick={(e) => handleMetaClick(e, m)}
                >
                  {text}
                </button>
              );
            }

            if (m.type === "empty") {
              return (
                <button
                  key={`m-${idx}`}
                  type="button"
                  className="summary-card__chip summary-card__meta-btn"
                  onClick={(e) => handleMetaClick(e, m)}
                >
                  empty
                </button>
              );
            }

            if (m.type === "time_ago") {
              const text = m?.value?.text ?? "";

              const content = (
                <>
                  <span className="summary-card__time-icon">
                    <ClockIcon />
                  </span>
                  <span className="summary-card__time-text">{text}</span>
                </>
              );
              return (
                <span key={`m-${idx}`} className="summary-card__time">
                  {content}
                </span>
              );
            }

            // fallback
            return null;
          })
        )}
      </div>
    </div>
  );
});